export class MemStack {

    public backbone: Array<any> = new Array<any>();
}
